module.exports = {
  fastDelivery: 'ដឹកជញ្ជូនរហ័សបំផុត',
  appointmentDelivery: 'កំណត់ម៉ោងទៅដល់',
  fastOrder: 'Speed 30min',
  // 待接单提示
  waitOrder: 'សូមទទួលការបញ្ជាទិញមុនពេល {args1} ',
  // 开始备餐
  preOrder: 'សូមចាប់ផ្ដើមរៀបចំអាហារមុនពេល {args1} ',
  // 完成备餐
  preMealOrder: 'សូមបញ្ចប់ការរៀបចំអាហារមុនពេល {args1}',
  // 备餐完成
  completeMealOrder: 'បានរៀបចំរួចរាល់ {args1}',
  // 处理取消申请
  processCancelOrder: 'សូមដាក់ស្នើរដំណើរការបោះបង់មុនពេល {args1}',
  // 完成订单
  completeOrder: 'បានបញ្ចប់ការបញ្ជាទិញរួចរាល់ {args1}',
  // 取消订单
  cancelOrder: 'ការបញ្ជាទិញត្រូវបានលុបចោលនៅលេខ {args1}',
  // 订单号
  orderNo: 'លេខបញ្ជាទិញ',
  // 下单时间
  orderTime: 'ម៉ោងបញ្ជាទិញ',
  orderDate: 'កាលបរិច្ឆេទ​បញ្ជា​ទិញ',
  showAll: 'មើលទាំងអស់',
  // 共{args}种商品
  allProduct: 'សរុបចំនួន{args1}ទំនិញ',
  orderTimes: 'ការបញ្ជាទិញលើកទី{args1}',
  // 配送费
  deliveryFee: 'សេវាដឹកជញ្ជូន',
  // 增值税
  vat: 'ពន្ធបន្ថែម',
  platformDiscount: 'App បញ្ចុះតម្លៃ',
  platformFull: 'App ចំណាយគ្រប់បញ្ចុះតម្លៃ',
  platformCoupons: 'ប័ណ្ដបញ្ចុះតម្លៃ',
  storeFull: 'ហាង ចំណាយគ្រប់បញ្ចុះតម្លៃ',
  storeShipping: 'ប័ណ្ណដឹកជញ្ជូន',
  storeFirstOrder: 'ហាង បញ្ជាទិញលើកដំបូង',
  storeCoupons: 'ប័ណ្ណហាងលក់',
  custPay: 'អតិថិជនបង់ប្រាក់',
  estimatedIncome: 'ហាងប៉ាន់ស្មានចំណូល',
  consigneeName: 'អ្នកទទួល',
  recipientAddress: 'អាសយដ្ឋានដឹកជញ្ជូន',
  orderStatus: 'ស្ថានភាពការបញ្ជាទិញ',
  deliveryStatus: 'ស្ថានភាពដឹកជញ្ជូន',
  noRemark: 'គ្មានការកត់សម្គាល់',
  remark: 'កត់សម្គាល់',
  productDetails: 'ព័ត៌មានលម្អិតអំពីផលិតផល',
  picture: 'រូបភាពទំនិញ',
  name: 'ឈ្មោះទំនិញ',
  specification: 'ការបញ្ជាក់ពីតម្លៃ ',
  attributes: 'គុណលក្ខណៈ',
  quantity: 'បរិមាណ',
  total: 'សរុប',
  price: 'តម្លៃទំនិញ',
  totalAmount: 'បរិមាណ​សរុប',
  totalNum: 'បរិមាណសរុប',
  writeReason: 'សូមបញ្ចូល{args1}មូលហេតុ',
  linkTel: 'លេខទំនាក់ទំនង',
  receiverPhone: 'ទូរស័ព្ទរបស់អតិថិជន',
  riderPhone: 'លេខទូរស័ព្ទអ្នកដឹកជញ្ជូន',
  stationPhone: 'សាខាដឹកជញ្ជូនទូរស័ព្ទ',
  automaticOrder: 'ទទួលការបញ្ជាទិញដោយស្វ័យប្រវត្តិ',
  mark: 'កូដសម្គាល់',
  acceptOrder: 'ទទួលការបញ្ជាទិញ',
  rejectOrder: 'មិនទទួលការបញ្ជាទិញ',
  reasonNull: 'ហេតុផលមិនអាចទទេបានទេ!',
  startTime: 'ពេលវេលាចាប់ផ្តើម',
  asOfTime: 'ពេលវេលាចាប់បញ្ចប់',
  prepareMeal: 'ចាប់ផ្ដើមរៀបចំ',
  prepareFinish: 'រៀបចំរួចរាល់',
  agreeRefund: 'យល់ព្រមបង្វិលប្រាក់',
  refuseRefund: 'បដិសេធបង្វិលប្រាក់',
  agreeCancel: 'យល់ព្រមការបោះបង់',
  rejectCancel: 'បដិសេធការបោះបង់',
  refundDesc: 'លម្អិតការបង្វិលប្រាក់',
  OriginalPrice: 'តម្លៃដើមសរុប',
  discountPrice: ' តម្លៃសរុបបន្ទាប់ពីបញ្ចុះតំលៃ',
  applying: 'ដាក់ស្នើរការលុប',
  refunding: 'ដាក់ស្នើរការបង្វិលប្រាក់',
  cancelled: 'បានបោះបង់',
  appointmentPass: 'ការបញ្ជាទិញត្រូវផុតកំណត់',
  promotionCode: 'កូដប្រម៉ូសិន',
  showDetail: 'ពត៌មានលម្អិតនៃផលិតផល',
  productGift: 'ទំនិញថែម',
  cancelReason: 'ហេតុផលសម្រាប់ការលុបចោល',
  selectReason: 'សូមជ្រើសរើសហេតុផល？',
  storeRating: 'ពិន្ទុហាង',
  goodEvaluateRate: 'ភាគរយវាយតម្លៃល្អ',
  evaluate: 'វាយតម្លៃ',
  replyOrNot: 'ឆ្លើយតប',
  replied: 'បានឆ្លើយតប​',
  unReplied: 'មិនបានឆ្លើយតប',
  custPhoto: 'រូបអតិថិជន',
  custNick: 'ឈ្មោះហៅក្រៅភ្ញៀវ',
  evaluateTime: 'ពេលវេលាវាយតម្លៃ',
  evaluateScore: 'ពិន្ទុ',
  evaluateContent: 'មាតិការវាយតម្លៃ',
  storeReply: 'ហាងឆ្លើយតប',
  replyTime: 'ពេលវេលាឆ្លើយតប',
  reply: 'ឆ្លើយតប',
  custEvaluate: 'ភ្ញៀវវាយតម្លៃ',
  replyorNot: 'ឆ្លើយតប',
  hasContent: 'មាតិកា',
  haveContent: 'មានមាតិកា',
  noContent: 'គ្មានមាតិកា',
  photo: 'រូបថត',
  requiredReply: 'កត់សម្គាល់(ទាមទារ 500 ពាក្យ)',
  allPicture: 'រូបភាព {num} សរុប',
  largeOrderTips: 'ការបញ្ជាទិញនេះពាក់ព័ន្ធនឹងបរិមាណដ៏ច្រើន សូមដោះស្រាយវាដោយប្រុងប្រយ័ត្ន',
  feedbackTitle:'មតិកែលម្អលើភាពខុសប្រក្រតី',
  contactInfo: 'លេខទំនាក់ទំនង',
  feedbackReason: 'មូលហេតុនៃមតិយោបល់',
  detailDesc: 'ការពិពណ៌នាលម្អិត',
  descPlaceholder: 'ពិពណ៌នាអំពីបញ្ហា/រំពឹងទុកវិធីដោះស្រាយ។ល។',
  pic: 'រូបភាពនៃមតិកែលម្អ',
  merchant :'ម្ចាស់ហាង',
  feedbackDetailTitle: 'ព័ត៌មានលម្អិតនៃមតិកែលម្អ',
  feedbackNo: 'លេខមតិកែលម្អ',
  feedbackRole: 'មតិរបស់លោកអ្នក',
  feedbackTime: 'ពេលវេលាមតិកែលម្អ',
  handleLog: 'ប្រវត្តិនៃដំណើរការ',
  pending: 'រងចាំដំណើរការ',
  processing: 'កំពុងដំណើរការ',
  Solved: 'បានដោះស្រាយ',
  Rejected: 'បានបដិសេធ',
  time: 'ពេលវេលា',
  type: 'ប្រភេទ',
  operatorName : 'ប្រតិបត្តិករ',
  logCnt: 'មាតិកាដំណើរការ',
  logStatus : 'ស្ថានភាពដំណើរការ',
  checkFeedback: 'ឆែកមើលមតិកែលម្អភាពខុសប្រក្រតី',
  issueOrder: 'មានសំណួរអំពីការបញ្ជាទិញ?',
  try: 'សាក',
  orderFeedback: 'ផ្តល់មតិកែលម្អលើភាពខុសប្រក្រតី',
  submitFeedback:'ដាក់ស្នើមតិកែលម្អ',
  acceptFeedback:'接取',
  handleFeedback:"处理",
  completeFeedback:"处理完成",
  solvedFeedback:"处理完成-已解决",
  vatRate: 'អត្រាពន្ធលើតម្លៃបន្ថែម',
  originalTotalPrice: 'ទំនិញតម្លៃសរុប',
  totalPriceAfterDiscount: 'តម្លៃសរុបបន្ទាប់ពីទំនិញបញ្ចុះតម្លៃ',
  pendingSettleTip: 'មិនទាន់បានទូទាត់（រំពឹងទុក {time} មុនពេលទូទាត់）',
  doneSettleTip: 'បានទូទាត់{time}',
  userPicked: 'បានទទួលអាហាររួចរាល់​',
  selfPickUp: 'ទៅយកអាហារ​',
  userPickedOrderTipTitle: 'រំលឹក',
  userPickedOrderTip: 'ប្រសិនបើអ្នកប្រើបានទទួលផលិតផលហើយ សូមចុច OK ដើម្បីបញ្ចប់មបុងបញ្ជាទិញ។',
}
